(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Initialize: hide all content containers
    const allContentContainers = document.querySelectorAll('.msbc-content');
    const navItems = document.querySelectorAll('.msbn-item-inner');
    const defaultNavItem = document.getElementById('shop-by-collection');
    const defaultContent = document.getElementById('shop-by-collection-content');

    // Function to reset to default state
    function resetToDefault() {
      // Remove active from all nav items and content containers
      navItems.forEach((item) => item.classList.remove('active'));
      allContentContainers.forEach((container) => container.classList.remove('active'));

      // Set default active: shop-by-collection
      if (defaultNavItem && defaultContent) {
        defaultNavItem.classList.add('active');
        defaultContent.classList.add('active');
      }
    }

    // Initialize on load
    allContentContainers.forEach((container) => {
      container.classList.remove('active');
    });
    resetToDefault();

    // Add mouseleave handler to .megamenu to reset to default
    // Target the megamenu that contains the shop-by content
    const megamenuInnerNew = document.querySelector('.megamenu-inner_new');
    const megamenu = megamenuInnerNew ? megamenuInnerNew.closest('.megamenu') : null;
    if (megamenu) {
      let resetTimeout;
      megamenu.addEventListener('mouseleave', function () {
        resetTimeout = setTimeout(function () {
          resetToDefault();
        }, 400);
      });
      megamenu.addEventListener('mouseenter', function () {
        if (resetTimeout) {
          clearTimeout(resetTimeout);
        }
      });
    }

    // Add click handlers to all nav items
    navItems.forEach((navItem) => {
      navItem.addEventListener('click', function () {
        const navId = this.id;
        const contentId = navId + '-content';
        const targetContent = document.getElementById(contentId);

        if (!targetContent) return;

        // Remove active from all nav items and content containers
        navItems.forEach((item) => item.classList.remove('active'));
        allContentContainers.forEach((container) => container.classList.remove('active'));

        // Add active to clicked nav item and corresponding content
        this.classList.add('active');
        targetContent.classList.add('active');
      });
    });
  })();

  (function () {
    // Initialize: Set mm-base as active on page load
    document.addEventListener('DOMContentLoaded', function () {
      const menuContainers = document.querySelectorAll('.mobile-menu-inner');
      const allContainersNoBase = document.querySelectorAll('.mobile-menu-inner:not(#mm-base)');
      const baseContainer = document.getElementById('mm-base');

      // Remove active from all containers
      menuContainers.forEach((container) => {
        container.classList.remove('active');
      });

      // Set mm-base as active by default
      if (baseContainer) {
        baseContainer.classList.add('active');
      }

      // Handle clicks on buttons with data-mm-target
      document.addEventListener('click', function (e) {
        const targetButton = e.target.closest('[data-mm-target]');
        if (targetButton) {
          e.preventDefault();
          const targetId = targetButton.getAttribute('data-mm-target');
          const targetContainer = document.getElementById(targetId);

          if (targetContainer) {
            // Remove active from all containers
            allContainersNoBase.forEach((container) => {
              container.classList.remove('active');
            });

            // Add active to target container
            targetContainer.classList.add('active');
            baseContainer.classList.add('slid');
          }
        }

        // Handle close button - return to base
        const closeButton = e.target.closest('.menu-close');
        if (closeButton) {
          e.preventDefault();
          menuContainers.forEach((container) => {
            container.classList.remove('active');
          });
          if (baseContainer) {
            baseContainer.classList.add('active');
            baseContainer.classList.remove('slid');
          }
        }

        // Handle back button - return to base
        const backButton = e.target.closest('.mmih-left');
        if (backButton) {
          e.preventDefault();
          allContainersNoBase.forEach((container) => {
            container.classList.remove('active');
          });
          if (baseContainer) {
            baseContainer.classList.add('active');
            baseContainer.classList.remove('slid');
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-page-content_form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // need to maintain parent container height when form is submitted otherwise it will collapse and it looks bad
  // give it some time to load and then get the height
  let ipcfWrapHeight = null;
  setTimeout(function() {
    const ipcfWrap = document.querySelector('.ipcf-wrap');
    if (ipcfWrap) {
      ipcfWrapHeight = ipcfWrap.offsetHeight;
    }
  }, 1500);
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn') && e.target.classList.contains('btn-primary') && e.target.type === 'submit') {
      if (ipcfWrapHeight !== null && window.innerWidth > 768) {
        const ipcfWrap = document.querySelector('.ipcf-wrap');
        if (ipcfWrap) {
          ipcfWrap.style.height = ipcfWrapHeight + 'px';
        }
      }
      
      const observer = new MutationObserver(function(mutations, obs) {
        const submittedMessage = document.querySelector('.submitted-message');
        if (submittedMessage) {
          obs.disconnect();
          
          submittedMessage.remove();
          
          const formWrap = document.querySelector('.ipcf-form-wrap');
          if (formWrap) {
            formWrap.classList.add('hidden');
          }
          
          const submitted = document.querySelector('.ipcf-submitted');
          if (submitted) {
            submitted.classList.add('active');
          }
          
          // Scroll to top of form on mobile
          if (window.innerWidth <= 768) {
            const ipcfWrap = document.querySelector('.ipcf-wrap');
            if (ipcfWrap) {
              const rect = ipcfWrap.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetY = rect.top + scrollTop - 150;
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
        }
      });
      
      const formContainer = document.querySelector('.ipcf-form');
      if (formContainer) {
        observer.observe(formContainer, {
          childList: true,
          subtree: true
        });
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megalinks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const headers = document.querySelectorAll('.link-columns_header[data-toggle]');

headers.forEach(header => {
header.addEventListener('click', function() {
const targetId = this.getAttribute('data-toggle');
const targetList = document.getElementById(targetId);
const isOpen = targetList.classList.contains('is-open');

// Toggle dropdown visibility
if (isOpen) {
targetList.classList.remove('is-open');
this.classList.remove('is-open');
} else {
targetList.classList.add('is-open');
this.classList.add('is-open');
}
});
});
});

  } catch(e) { console.error(e); }
})();
})();
